import GameParameterInterface from '@/models/game/parameters/interface'

export interface CraneGameLotteryParameter {
  prize: CraneGamePrize
  generalValue: number
}

interface CraneGamePrize {
  prizeImage: string,
}

export default class CraneParameter implements GameParameterInterface {
  constructor(private parameter: CraneGameLotteryParameter) { }

  createSetOption(): CraneGameLotteryParameter {

    return {
      prize: this.parameter.prize,
      generalValue: this.parameter.generalValue,
    }
  }

  get guideUrl(): string {
    return ''
  }
}
